import styled from "styled-components";
import App from "../constants/app";

export const TopBarContainer = styled.div`
  background-color: ${props => props.theme.topBar.background};
  width: 100%;
`;

export const TopBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  width: 100%;
  height: ${App.TOP_BAR_HEIGHT};
`;

export const TopBarLeft = styled.div`
  height: 100%;
`;

export const TopBarRight = styled.div`
  display: flex;
  height: 100%;
`;

export const TopBarMenu = styled.div`
  display: flex;
  flex-direction: row;
  padding-top: 0.25rem;
  height: 100%;
  margin: 0;
  line-height: normal;
  font-size: 12px;
`;

export const TopBarMenuTab = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  max-width: 10rem;
  height: 100%;
  cursor: ${props => {
    const cursor = props.active ? "default" : "pointer";
    return props.disabled ? "not-allowed" : cursor;
  }};
  filter: grayscale(${props => (props.disabled ? 1 : 0)});
  background-color: ${props =>
    props.active
      ? props.theme.topBar.tab.backgroundActive
      : props.theme.topBar.tab.backgroundInactive};
  border-top: ${props =>
    props.active
      ? `2px solid ${props.theme.topBar.tab.selectedTabAccent}`
      : "0"};
  border-right: 1px solid ${props => props.theme.topBar.tab.borderColor};
  border-left: 1px solid ${props => props.theme.topBar.tab.borderColor};
  box-sizing: border-box;
  padding: 0 0.25rem;
  border-radius: 5px 5px 0 0;
  margin-right: 0.25rem;
  font-size: 11px;
  line-height: normal;
`;

export const MenuTabContent = styled.div`
  display: flex;
  align-content: center;
  justify-content: center;

  > img {
    margin-left: 0.25rem;
    margin-right: 0.25rem;
    height: 1rem;
  }
`;

export const TopBarTitle = styled.div`
  font-family: "ReplicaLX";
  display: flex;
  align-items: center;
  font-size: 24px;
  height: 100%;
  padding: 0 0.25rem;
  color: ${props => props.theme.topBar.title};
  cursor: default;
  user-drag: none;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-drag: none;
  -webkit-user-select: none;
  -ms-user-select: none;
`;



// WEBPACK FOOTER //
// ./app/styled-components/TopBar.js